/**
 * Reads back the SQL Server connect-timeout headline main puts in front of the raw driver text
 * (`electron/connection-managers/mssqlConnectErrorMessage.ts`, Windows release pass B3), so the connect notice
 * (`connectionErrorPresentation.ts`) says that advice — the dialed target's likely cause, e.g. a local Developer /
 * Express server with TCP/IP off: clear the Port field — instead of only its generic "did not answer in time" line
 * (review round 2).
 *
 * Main composes four variants (no target, an automatic port, a local server on an explicit port, a remote one); each ends
 * with its own fixed sentence, listed below. `src/test/coupling/mssqlTimeoutNoticeCoupling.test.ts` runs main's REAL
 * composer through this reader for every variant, so a reworded headline fails there instead of silently falling back.
 */
const HEADLINE = /^SQL Server (?:at .+? )?did not answer within \d+ seconds\. .*?(?:reachable, then try again\.|instance names are right\.|through the local protocols instead\.|no firewall or VPN blocks it\.)/u;

/** The headline at the start of a connect error, or undefined when main composed none. */
export function mssqlTimeoutHeadlineIn(text: string): string | undefined {
  return HEADLINE.exec(text)?.[0];
}
